import { useCallback, useState } from 'react';

interface UseGetCepDetailsAtViaCepI {
  loading?: boolean;
  getCepDetailsAtViaCep: (
    cep: string,
    _catch?: (error: string) => void,
  ) => Promise<ViaCepFunctionI>;
}

interface ViaCepWebServiceGetResponseI {
  cep: string;
  logradouro: string;
  complemento: string;
  bairro: string;
  localidade: string;
  uf: string;
  ibge: string;
  gia: string;
  ddd: string;
  siafi: string;
}

interface ViaCepParsedResponseI {
  cep: string;
  street: string;
  neighbourhood: string;
  city: string;
  state: string;
  ddd: string;
  complement?: string;
}

interface ViaCepFunctionI {
  valid: boolean;
  data?: ViaCepParsedResponseI;
}

const parseViaCepWebServiceGetResponse = (
  viaCepWebServiceResponse: ViaCepWebServiceGetResponseI,
): ViaCepParsedResponseI => ({
  cep: viaCepWebServiceResponse.cep,
  city: viaCepWebServiceResponse.localidade,
  ddd: viaCepWebServiceResponse.ddd,
  neighbourhood: viaCepWebServiceResponse.bairro,
  state: viaCepWebServiceResponse.uf,
  street: viaCepWebServiceResponse.logradouro,
  complement: viaCepWebServiceResponse.complemento,
});

export default (): UseGetCepDetailsAtViaCepI => {
  const [loading, setLoading] = useState(false);

  const getCepDetailsAtViaCep = useCallback(
    async (cep: string, _catch?: (error: string) => void): Promise<ViaCepFunctionI> => {
      console.log('init getGetCepDetailsAtViaCep');

      const cepOnlyNumber = cep?.replace(/\D/g, '');
      const viaCepFinalUrl = `https://viacep.com.br/ws/${cepOnlyNumber}/json/`;

      let data: ViaCepFunctionI = {
        valid: false,
      };

      setLoading(true);

      try {
        await fetch(viaCepFinalUrl, {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
          .then(response => response.json())
          .then(viaCepData => {
            if (viaCepData.erro)
              throw new Error('Este CEP não foi encontrado! Preencha os campos manualmente.');

            const parsedData = parseViaCepWebServiceGetResponse(viaCepData);

            data = {
              data: parsedData,
              valid: true,
            };
          });

        return data;
      } catch (error) {
        console.error('error getGetCepDetailsAtViaCep', error);
        _catch && _catch(error);
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  return {
    loading,
    getCepDetailsAtViaCep,
  };
};
